<template>
  <sp-select
    v-preserve-properties:items="items"
    v-preserve-properties:multiple="filter.multiple"
    class="sp-index-filters-select"
    :label="filter.label"
    :prompt="filter.prompt"
    :placeholder="filter.placeholder"
    :value.prop="value"
    searchable
    :keep-open-on-select="filter.multiple"
    :data-testid="TestId.admin.indexFilterSelect"
    :item-test-id="TestId.admin.indexFilterOption"
    @change="handleChange"
  ></sp-select>
</template>

<script setup>
import { vPreserveProperties } from "#ce/utils/property-bindings";
import { computed } from "vue";
import { TestId } from "#/test-ids";
import { useIndexFiltersStore } from "#ce/apps/SpAdmin/SpIndexFilters/store/index-filters";

const props = defineProps({ filter: { type: Object, required: true } });
const emit = defineEmits(["change"]);
const store = useIndexFiltersStore();
const value = computed(() => store.selectedFor(props.filter));
const items = computed(() => {
  const groups = new Map();
  const result = [];

  for (const item of props.filter.items) {
    if (!item.group) {
      result.push(item);
      continue;
    }

    if (!groups.has(item.group)) {
      const group = { title: item.group, children: [] };
      groups.set(item.group, group);
      result.push(group);
    }

    groups.get(item.group).children.push(item);
  }

  return result;
});

function handleChange(event) {
  store.setFilterValue(props.filter, event.target.value);
  emit("change");
}
</script>
